import { toOperation } from './types';

export const LOAD_START_MARK_KEY = 'PROJECT_CUSTOM_ROLES_LOAD_START_MARK_KEY';
export const LOAD_END_MARK_KEY = 'PROJECT_CUSTOM_ROLES_LOAD_END_MARK_KEY';
export const LOAD_READY_MARK_KEY = 'PROJECT_CUSTOM_ROLES_LOAD_READY_MARK_KEY';

export const MANAGE_CUSTOM_ROLES_APP_NAME = 'project-settings-apps.manage-custom-roles';
export const MAX_CHAR_ROLE_NAME = 52;
export const MAX_CHAR_ROLE_DESCRIPTION = 170;

export const EDIT_PERMISSION = 'EDIT';
export const DELETE_PERMISSION = 'DELETE';
export const MODIFY_ACTORS_PERMISSION = 'MANAGE_MEMBERS';

export const LEARN_MORE_LINK_JSW = 'https://confluence.atlassian.com/x/lYEtOQ';
export const LEARN_MORE_LINK_JSD =
	'https://support.atlassian.com/jira-service-desk-cloud/docs/overview-of-permissions-in-next-gen-service-desks/';

export const PERMISSION_TYPE_DEFAULT = 'DEFAULT_PERMISSIONS';
export const PERMISSION_TYPE_APP = 'APP_PERMISSIONS';

export const BANNER_KEYS = {
	ADMINISTER_PROJECTS: 'administerProjects',
	MANAGE_SPRINTS_PERMISSION: 'manageSprint',
	VIEW_DEV_TOOLS: 'viewDevTools',
	WORK_ON_PROJECT_ISSUES: 'workOnProjectIssues',
	MANAGE_PROJECT_ISSUES: 'manageProjectIssues',
	CREATE_ISSUES: 'createIssues',
	COLLABORATE_ON_ISSUES: 'collaborateOnIssues',
	VIEW_PROJECT_ISSUE: 'viewProjectIssue',
	MANAGE_PROJECT_REQUESTS: 'manageProjectRequests',
	VIEW_PROJECT_REQUESTS: 'viewProjectRequests',
	CREATE_REQUESTS: 'createRequests',
	WORK_ON_PROJECT_REQUESTS: 'workOnProjectRequest',
	COLLABORATE_ON_PROJECT_REQUESTS: 'collaborateOnProjectRequests',
} as const;

export const VERSION_TOKEN = {
	counter: 0,
	id: '00000000-0000-0000-0000-000000000000',
} as const;

export const APP_PERMISSION_KEY = 'APP_PERMISSIONS';

export const CREATE = toOperation('CREATE');
export const CLONE = toOperation('CLONE');
export const EDIT = toOperation('EDIT');

export const TEAM_NAME = 'olympus';
